import { render } from "./ui-textarea.vue?vue&type=template&id=40ee0c98&ts=true"
import script from "./ui-textarea.vue?vue&type=script&lang=ts"
export * from "./ui-textarea.vue?vue&type=script&lang=ts"

import "./ui-textarea.vue?vue&type=style&index=0&id=40ee0c98&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__